import * as React from 'react';
import './ImageGallery.css';
export class ImageGallery extends React.Component {
    /**
     * le retour de la fonction
     * @returns {JSX.Element}
     */
    render() {
        return(
            <div className="hvrbox">
                <img src={require('./frame-landscape.png')} alt="Mountains" className="hvrbox-layer_bottom"/>
                <div className="hvrbox-layer_top">
                    <div className="hvrbox-text">Afficher les médias</div>
                </div>
            </div>
       );
    }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/internalComponents/ImageGallery.tsx